import React from 'react';

export type DatePickerInputProps = {
  value: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  id: string;
};

export { default as DatePickerInput } from './DatePickerInput';
